import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { createElement } from "react";
import { Box, Divider } from "braid-design-system";
import { isDivider } from "../../ApacCandidateHeader.mjs";
import { AuthLinks } from "../AuthLinks/AuthLinks.mjs";
import { ExpandableTab } from "../ExpandableTab/ExpandableTab.mjs";
import { ResponsiveTab } from "../ResponsiveTab/ResponsiveTab.mjs";
import { root, fadeInBase, fadeInShow } from "./ResponsiveDropdownMenu.css.mjs";
const NonMemberTabs = ({ item }) => /* @__PURE__ */ jsx(Box, { padding: "small", children: /* @__PURE__ */ jsx(AuthLinks, { authItems: item }) });
const DIVIDER_PADDING = "xsmall";
const TabItemWithCustomComponent = ({
  item
}) => /* @__PURE__ */ jsx(Box, { paddingY: isDivider(item.customComponent) ? DIVIDER_PADDING : "none", children: /* @__PURE__ */ jsx(item.customComponent, {}) });
const ResponsiveDropdownMenuContent = ({
  navItem,
  isAuthenticated
}) => /* @__PURE__ */ jsx(Fragment, { children: navItem.map((item, index) => {
  if (item) {
    switch (item.objectType) {
      case "AuthNonMemberItem":
        if (isAuthenticated) {
          return /* @__PURE__ */ jsx(NonMemberTabs, { item }, `nonMemberTabs${index}`);
        }
        break;
      case "TabItem":
        return /* @__PURE__ */ jsx(ResponsiveTab, { tabItem: item }, `responsiveTab_${index}`);
      case "TabItemWithChild":
        return /* @__PURE__ */ createElement(ExpandableTab, { ...item, key: `expandableTab_${index}` });
      case "TabItemWithCustomComponent":
        return /* @__PURE__ */ jsx(
          TabItemWithCustomComponent,
          {
            item
          },
          `tabItemWithCustomComponent${index}`
        );
    }
  }
  return null;
}) });
const ResponsiveDropdownMenu = ({
  navItem,
  isMenuOpen,
  isAuthenticated
}) => {
  const { primary } = navItem instanceof Array ? { primary: navItem } : navItem;
  const primaryContent = /* @__PURE__ */ jsx(
    ResponsiveDropdownMenuContent,
    {
      navItem: primary,
      isAuthenticated
    }
  );
  return /* @__PURE__ */ jsxs(
    Box,
    {
      background: "body",
      display: [isMenuOpen ? "block" : "none", "none"],
      flexGrow: 1,
      className: [
        root,
        fadeInBase,
        { [fadeInShow]: isMenuOpen }
      ],
      children: [
        /* @__PURE__ */ jsx(Box, { background: "surface", paddingBottom: DIVIDER_PADDING, children: primaryContent }),
        /* @__PURE__ */ jsx(Divider, {})
      ]
    }
  );
};
export {
  DIVIDER_PADDING,
  ResponsiveDropdownMenu
};
